// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Zv8g","alertIcon":"ConfirmModal_alertIcon__2eAO9"};